import { Box, Checkbox } from "@dxp-feed/ui";
import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from "@dxp-feed/ui/Accordion";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { setFavouriteMessage } from "@/utils/redux/favouriteProduct";
import { setShoppingMessage } from "@/utils/redux/shoppingList";
import { useSelector } from "react-redux";
import { RootState } from "@/utils/redux/store";
import { FLYER_PROMOTIONS_SOURCE } from "@/utils/constant";
const FlyerFilters = ({ onFilterChange }: any) => {
  const [checked, setChecked] = useState(false);
  const productFilters = useSelector(
    (state: RootState) => state.productsSlice.filter
  );
  const { Flyers } = useAppSelector((state) => state.getProductAemDataSlice);
  const [flyerData, setFlyerData] = useState(Flyers as typeof Flyers);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (Flyers?.title && Flyers?.flyerOptions) {
      setFlyerData(Flyers);
    }
  }, [Flyers]);

  useEffect(() => {
    setChecked(productFilters.some((item) => item.filter === "flyer"));
  }, [productFilters.length]);

  const handleChange = (event: any) => {
    dispatch(setFavouriteMessage());
    dispatch(setShoppingMessage());
    const isChecked = event.target.checked;
    setChecked(isChecked);

    const currdate = Math.floor(Date.now() / 1000);
  
    const filterValue = `promotions.promotionComplianceFlag:true AND promotions.startDate<=${currdate} AND promotions.endDate>=${currdate} AND promotions.source:${FLYER_PROMOTIONS_SOURCE}`;

    onFilterChange(isChecked ? filterValue : "");
  };

  const index = 0;
  return (
    <Accordion
      className="flex flex-col gap-6 lg:gap-4 border-b border-grey350 mt-6 lg:mt-4"
      multiplePanelOpen={true}
    >
      <AccordionItem id={`itemFlyer-${index}`} key={`itemFlyer-${index}`}>
        <AccordionHeader
          id={`itemFlyer-${index}`}
          className="font-bold !px-0 pt-0 pb-2 text-[16px] lg:text-[14px] group [&_.demo-icon]:w-6 [&_.demo-icon]:h-6 [&_.demo-icon]:flex [&_.demo-icon]:items-center [&_.demo-icon]:justify-center"
        >
          {flyerData?.flyerOptions?.flyers}
        </AccordionHeader>
        <AccordionPanel
          id={`itemFlyer-${index}`}
          className="[&>div]:pl-0 [&>div]:flex [&>div]:flex-col [&>div]:gap-2 [&>div]:py-0 [&>div]:pb-2 lg:[&>div]:py-2 [&>div]:border-t [&>div]:border-none lg:[&>div]:border-grey350 [&>div]:overflow-x-hidden [&>div]:overflow-y-auto [&>div]:max-h-[280px] [&>div]:scroll-bar-grey"
        >
          <Box as="div" className="flex items-center gap-2">
            <Checkbox
              id={`checkboxflyer-${index}`}
              className="m-[15px] min-w-[18px] min-h-[18px]"
              checked={checked}
              onChange={handleChange}
            />
            <label
              htmlFor={`checkboxflyer-${index}`}
              className="text-[14px] peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
            >
              {flyerData?.title}
            </label>
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FlyerFilters;
